import React from "react"
import { LoadingAnim } from "../assets"
import { Modal } from "./Modal"

export type LoadingProps = {
  visible: boolean
}

export const Loading: React.FC<LoadingProps> = ({ visible }) => {
  return (
    <Modal visible={visible}>
      <div className={"container"}>
        <LoadingAnim />
      </div>

      {/*language=Stylus*/}
      <style jsx>{`
        .image__loading {
          width 100px
          height 100px
        }
      `}</style>
    </Modal>
  )
}
